import { Injectable, signal } from '@angular/core';

export interface ConfirmDialogOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'default';
}

type ResolvedConfirmDialogOptions = Required<ConfirmDialogOptions>;

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  private readonly isOpenSignal = signal(false);
  private readonly optionsSignal = signal<ResolvedConfirmDialogOptions | null>(null);
  private resolver: ((result: boolean) => void) | null = null;

  readonly isOpen = this.isOpenSignal.asReadonly();
  readonly options = this.optionsSignal.asReadonly();

  confirm(options: ConfirmDialogOptions): Promise<boolean> {
    this.resolver?.(false);

    this.optionsSignal.set({
      confirmLabel: 'Eliminar',
      cancelLabel: 'Cancelar',
      variant: 'danger',
      ...options,
    });
    this.isOpenSignal.set(true);

    return new Promise<boolean>((resolve) => {
      this.resolver = resolve;
    });
  }

  resolve(result: boolean): void {
    this.isOpenSignal.set(false);
    this.resolver?.(result);
    this.resolver = null;
  }
}
